import VeriflytTicketEditor from "./veriflyt-ticket-editor";
export default VeriflytTicketEditor;